// extracted by mini-css-extract-plugin
export default {"container":"gFDwuQ","icon":"ptrV7P","text":"rQu6lz mz-success-label"};